import * as yup from "yup";

const emergencyContactLoginValidator = yup
  .object({
    phone: yup
      .string()
      .required("Phone is required")
      .test("phone", "Invalid phone format. e.g 912345678", (value) => {
        return /^9[0-9]{8}$/.test(value);
      }),
    password: yup.string().required("Password is required"),
  })
  .required();

export default emergencyContactLoginValidator;
